export default "__VITE_ASSET__DH0Dq$h1__"